import { Button } from "@2u-landing-pages/components";
import { usePageState } from "@2u-landing-pages/providers";
import EventClient from "@2u-landing-pages/utils/event-client";
import { Drawer as BricksDrawer, ButtonGroup } from "@red-digital/bricks";
import React, { Fragment } from "react";
import { Banner } from "../Banner";
import { Form } from "../Form";
import { DrawerProps } from "./Drawer.types";

import { TypeFormWithoutUnresolvableLinksResponse } from "@2u-landing-pages/types";
// @ts-ignore
import styles from "./Drawer.module.scss";

const componentMap = {
  form: Form,
};

export const Drawer: React.FC<DrawerProps> = ({ fields, inspector = () => null, isLoading }) => {
  const { state, dispatch } = usePageState();
  const { closeButton, banner, template } = fields;
  const Component = componentMap[(template?.sys?.contentType?.sys?.id || "") as keyof typeof componentMap];

  const closeDrawer = () => {
    EventClient.applicationClicked({
      webElement: {
        elementType: "Landing Page",
        htmlId: window.location.href,
        location: "Drawer",
        position: "Background",
      },
    });
    dispatch({ type: "CLOSE_DRAWER" });
  };

  return (
    <Fragment>
      {banner && <Banner className={styles.banner} {...banner?.fields} inspector={inspector} location="Drawer" />}
      {Component && (
        <BricksDrawer className={styles.drawer} isOpen={state.isDrawerOpen} onClose={closeDrawer} position="bottom">
          <Component
            {...(template?.fields as TypeFormWithoutUnresolvableLinksResponse["fields"])}
            inDrawer
            isLoading={isLoading}
            topSlot={
              closeButton && closeButton?.fields ? (
                <ButtonGroup placement="center" className={styles.buttonWrapper}>
                  <Button
                    variant={closeButton?.fields?.variation}
                    color={closeButton?.fields?.color}
                    size={closeButton?.fields?.size}
                    icon={closeButton?.fields?.icon}
                    onClick={() => {
                      if (closeButton?.fields?.action === "CLOSE_DRAWER") {
                        dispatch({ type: closeButton.fields.action });
                      }
                    }}
                    location="Drawer"
                  >
                    {closeButton?.fields?.label}
                  </Button>
                </ButtonGroup>
              ) : null
            }
          />
        </BricksDrawer>
      )}
    </Fragment>
  );
};
